import { type TextLayer } from '@meitu/saas-editor-core/es/layers/text-layer';
import { OpacitySlider } from '@/components/opacity-slider';
import { useEditor } from '@/hooks/use-editor';
import { useLayerProps } from '../../hooks';
import { type WidgetCommonProps } from '../../types';
import { Tracker } from '../../utils';

type Props = WidgetCommonProps;

export const LayerOpacity: React.FC<Props> = ({ layerId, recordId }) => {
    const editor = useEditor();
    const opacity = useLayerProps(editor, (layer) => {
        return layer ? layer.opacity : 1;
    }) as number;

    const layerOpacity = ~~(opacity * 100);

    const setOpacity = (value: number, options = { writeHistory: true }) => {
        editor.getInstance<TextLayer>('TextLayer').setLayerOpacity(layerId, value / 100, options);

        if (options.writeHistory) {
            Tracker.setLayerOpacity({
                recordId,
                stageType: editor.services.editor.getCanvasType(),
                opacity: value,
            });
        }
    };

    return (
        <OpacitySlider
            value={layerOpacity}
            onChange={(value) => setOpacity(value, { writeHistory: false })}
            onAfterChange={(value) => setOpacity(value, { writeHistory: true })}
        />
    );
};
